import { PureComponent } from 'react';

export class PencilIcon extends PureComponent {
  render() {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" {...this.props}>
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M9.598 3.35a1.072 1.072 0 0 0-1.517 0l-.38.38-5.307 5.314.001.002-.167.167S1.694 9.75.49 13.638a49.894 49.894 0 0 0-.15.488l-.049.165a84.81 84.81 0 0 0-.116.39c-.087.294-.298.956-.06 1.196.231.231.9.028 1.193-.059l.388-.116.172-.052.182-.056.223-.069.065-.02c3.699-1.152 4.363-1.692 4.418-1.742l.005-.004.171-.172.012.012 5.308-5.314.379-.38a1.074 1.074 0 0 0 0-1.518L9.598 3.351zM6.15 13.074a.704.704 0 0 1-.045.028l-.014.009c-.177.105-.695.378-1.953.833a37.7 37.7 0 0 1-.474.168l-1.788-1.79c.058-.169.114-.33.168-.478.454-1.263.727-1.783.832-1.96l.007-.011a2.164 2.164 0 0 1 .03-.047l.13-.13 3.24 3.243-.133.135zm9.514-9.722L12.631.314a1.072 1.072 0 0 0-1.517 0l-.758.76a1.074 1.074 0 0 0 0 1.518l3.033 3.036c.419.42 1.098.42 1.517 0l.758-.759a1.074 1.074 0 0 0 0-1.518z"
        />
      </svg>
    );
  }
}
